module.exports = __webpack_public_path__ + "images/pages/lp/bulk_estimate_guide_1_cfe71afaea6bb0d7c40b9d1e33cb128d.png";